import createKeyFactory, { FactoryQueryParams, KEYS } from 'utils/createKeyFactory';

const marketPlaceFactory = {
  ...createKeyFactory([KEYS.MARKETPLACE]),
  pricingGrid: (params?: { amount?: string }) => [
    ...marketPlaceFactory.all(),
    'pricing-grid',
    ...marketPlaceFactory.list(params),
  ],
  walletHistory: (params?: FactoryQueryParams) => [
    ...marketPlaceFactory.all(),
    'wallet-history',
    ...marketPlaceFactory.list(params),
  ],
  wallet: () => [...marketPlaceFactory.all(), 'wallet'],
  payout: () => [...marketPlaceFactory.all(), 'payout'],
  bankAccount: () => [...marketPlaceFactory.all(), 'bankAccount'],
  paymentMethods: (params?: FactoryQueryParams) => [
    ...marketPlaceFactory.all(),
    'paymentMethods',
    ...marketPlaceFactory.list(params),
  ],
  walletHistoryDetail: (params: { type: string; id: string }) => [
    ...marketPlaceFactory.all(),
    'walletHistoryDetail',
    ...marketPlaceFactory.list(params),
  ],
  invoices: (id: string) => [...marketPlaceFactory.all(), 'invoices', id],
  salesSummary: () => [...marketPlaceFactory.all(), 'salesSummary'],
  compensationDetail: (id: string) => [...marketPlaceFactory.all(), 'compensationDetail', id],
};

export default marketPlaceFactory;
